var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"logo",staticStyle:{"margin":"0 auto","display":"block"},attrs:{"src":require("@/assets/fes-logo.svg")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }